<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Forgot password</h4>
                                    <p>Please enter your registered mobile number</p>
                                </div>
                                 <span class="text-danger text-sm">{{errorMessage }}</span>
                                    <span class="text-danger text-sm">{{ errors.first('mobileNo') }}</span>


                                <vs-input type="text"  v-validate="'min:10|max:10'" name="mobileNo" label-placeholder="Mobile No" v-model="phoneNo" class="w-full mb-8" />
                                <vs-button type="border" to="/login" class="px-4 w-full md:w-auto">Back To Login</vs-button>
                                <vs-button class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0" @click="sendOtp" :disabled="!validateForm">Submit</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
            <vs-popup class="holamundo" title="OTP" :active.sync="popupActive">
      <p>Please enter the otp send to your mobile number</p>
        <span class="text-danger text-sm">{{otpError }}</span>
        
       <vs-input
                                        type="text"
                                       
                                        data-vv-validate-on="blur"
                                        data-vv-as="Otp"
                                        name="otp"
                                        label-placeholder="Otp"
                                        placeholder="Otp"
                                        v-model="otp"
                                        class="mt-6" />

        <vs-button id="button-with-loading" class="float-center vs-con-loading__container mt-3" @click="login" :disabled="!validateOtp">Submit</vs-button>

    </vs-popup>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            phoneNo: '',
            popupActive:false,
            otp:'',
            otpError:'',
            errorMessage:''
        }
    },
     computed: {
        validateForm() {
            return !this.errors.any() && this.phoneNo != '' ;
        },
        validateOtp(){
            return this.otp !='' ;
        }
    },
     methods: {
        sendOtp() {
            if (!this.validateForm) return false
            
            var request={
                phoneNo:this.phoneNo,
                
            }
             this.$http.post(
                    "getUserLoginOtp",
                    JSON.stringify(request),
                     {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    if(response.data.statusCode==200){
                       this.popupActive=true;
                    }else{
                        this.errorMessage=response.data.message;
                    }
                    
                });
          
           
        },
         login() {
          this.popupActive=false;
            var request={
                name:this.phoneNo,
                password:this.otp
            }
            this.$http
                .post(
                    "authenticate",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json",
                            "otp":'Y'
                        }
                    }
                )
                .then(response => {
                   
                    this.$session.start();
                    this.$session.set("userId", response.data.data.userId);
                    this.$session.set("userName", response.data.data.userName);
                    this.$session.set("userCategoryId", response.data.data.userCategoryId);
                    this.$session.set("companyId", response.data.data.companyId);
                    this.$session.set("companyName", response.data.data.companyName);
                    this.$session.set("userToken", response.data.data.userToken);
                    this.$session.set('role', 'Clinic');
                    this.$router.push('/Overview');
                    

                }).catch(error => {
                  
                    this.popupActive=true;
                    this.otpError = "Invalid Otp";
                    // this.$vs.loading.close("#button-with-loading > .con-vs-loading")
                });

        }
    }
}
</script>
